__webpack_require__.p = "/pokeapi/";